import {
  DataTable,
  FlexBox,
  IconButton,
  Page,
  Timestamp,
} from '@dixa/lib-shared-habla';
import { EmailDraftT } from 'lib-shared-legacy-types';
import moment from 'moment-timezone';

// eslint-disable-next-line no-restricted-imports
import { composeEmailActions } from 'components/shared/composeEmail/actions/composeEmailActions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

export const DraftsView = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const { emailDrafts, meta } = useAppSelector((state) => state.composeEmail);

  const handleEdit = (draft: EmailDraftT) => {
    dispatch(
      composeEmailActions.composeEmailOpenModal({
        initialValues: draft,
      }),
    );
  };

  const handleRemove = (draft: EmailDraftT) => {
    dispatch(
      composeEmailActions.composeEmailRemoveDraft({
        timestamp: draft.timestamp,
      }),
    );
  };

  return (
    <Page>
      <Page.Head title="Email drafts" />

      <Page.Section>
        <DataTable
          data={emailDrafts as EmailDraftT[]}
          columns={[
            {
              label: 'From',
              selector: (draft) => {
                return draft.fromEmails ?? <em>No sender</em>;
              },
            },
            {
              label: 'To',
              selector: (draft) => {
                return draft.toUser?.[0]?.user?.email ?? <em>No receiver</em>;
              },
            },
            {
              label: 'Subject',
              selector: (draft) => {
                return draft.subject ?? <em>No subject</em>;
              },
            },
            {
              label: 'Message',
              selector: (draft) => {
                return draft.message ?? <em>No message</em>;
              },
            },
            {
              label: 'Created',
              selector: (draft) => {
                return (
                  <Timestamp
                    time={moment(draft.timestamp ?? Date.now()).toISOString()}
                    relative
                  />
                );
              },
            },
            {
              label: '',
              selector: (draft) => {
                return (
                  <FlexBox>
                    <IconButton
                      variant="tertiary"
                      icon="pen"
                      onClick={() => handleEdit(draft)}
                    />

                    <IconButton
                      variant="tertiary"
                      icon="trash"
                      onClick={() => handleRemove(draft)}
                    />
                  </FlexBox>
                );
              },
              style: {
                width: 0,
              },
            },
          ]}
          tableStatusProps={{
            loading: meta.getDrafts === 'loading',
            emptyState:
              meta.getDrafts === 'succeeded' && !emailDrafts.length
                ? {
                    title: 'No email drafts',
                    description: "You haven't saved any email drafts yet.",
                  }
                : undefined,
          }}
        />
      </Page.Section>
    </Page>
  );
};
